import React, { Fragment, useContext, useEffect } from "react";
import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";
import Sidebarone from "./Sidebarone";
import Uppersidebar from "./Uppersidebar";
import Footer from "./Footer";
import SidebarContext from "./sidebarcontext/SidebarContext";
import { Alert } from "./Alert";

export default function Layout({ children }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const { menutoggle, setMenutoggle, msg, setMsg, alert } = useContext(SidebarContext);

  // Initialize sidebar state based on screen size
  useEffect(() => {
    setMenutoggle(isSmallScreen);
  }, [isSmallScreen, setMenutoggle]);

  // Clear alert message after 3 seconds
  useEffect(() => {
    if (msg?.msg) {
      const timer = setTimeout(() => setMsg({}), 3000);
      return () => clearTimeout(timer);
    }
  }, [msg, setMsg]);

  const drawerWidth = 240;

  return (
    <Fragment>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        {/* Sidebar */}
        <Box component="nav" sx={{ width: { lg: drawerWidth }, flexShrink: { lg: 0 } }}>
          <Drawer
            variant={isSmallScreen ? "temporary" : "persistent"}
            open={!menutoggle}
            onClose={() => setMenutoggle(true)}
            ModalProps={{ keepMounted: true }}
            sx={{
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
              },
              display: { xs: 'block', lg: 'block' },
            }}
          >
            <Sidebarone />
          </Drawer>
        </Box>

        {/* Main content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: { lg: `calc(100% - ${drawerWidth}px)` },
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: { lg: menutoggle ? `-${drawerWidth}px` : 0 },
          }}
        >
          <Uppersidebar />
          <Box sx={{ p: 2, mb: 2 }}>
            {children}
          </Box>
          <Footer />
        </Box>
      </Box>

      {/* Alert messages */}
      {msg?.msg && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 20,
            right: 20,
            p: 2,
            backgroundColor: msg.type === 'error' ? 'error.main' : 'success.main',
            color: 'white',
            borderRadius: 1,
            boxShadow: 3,
          }}
        >
          {msg.msg}
        </Box>
      )}

      <Alert trigger={alert} />
    </Fragment>
  );
}
